import React, { useState } from "react";
import Sidebar from "@/components/Sidebar";

function AppLayout(props) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const user = props.user;
  const setUser = props.setUser;
  const children = props.children;

  return (
    <div className="app-layout">
      <Sidebar 
        user={user} 
        collapsed={sidebarCollapsed} 
        setCollapsed={setSidebarCollapsed} 
      />
      <main className="main-content bg-muted/30 min-h-screen">
        {children}
      </main>
    </div>
  );
}

export { AppLayout };
export default AppLayout;
